<script setup>

import {storeToRefs} from "pinia";
import {onMounted} from "vue";
import {useGlobalStore} from "@/stores/global.store";
import {useUserPoapStore} from "@/stores/userPoap.store";

const userPoapStore = useUserPoapStore();
const globalStore = useGlobalStore();
const {userPoaps, search} = storeToRefs(userPoapStore);

onMounted(async () => {
    globalStore.loading = true;
    await userPoapStore.fetchAll();
    globalStore.loading = false;
});

const doSearch = async () => {
    await userPoapStore.fetchAll();
}

</script>

<template>
    <van-space direction="vertical" fill>
        <van-search v-model="search" @search="doSearch" @cancel="doSearch"
                    placeholder="Search for your goals"/>
        <div v-if="userPoaps.length === 0">
            <van-empty image="search" description="Nothing found"/>
        </div>
        <div v-if="userPoaps.length > 0">
            <van-cell-group inset
                            v-for="userPoap in userPoaps" :key="userPoap.id">
                <van-cell is-link :to="'/poap/' + userPoap.id">
                    <template #title>
                        <b>{{ userPoap.name }}</b>
                    </template>
                </van-cell>
                <van-cell title="Description" :value="userPoap.description"/>
                <van-cell title="Start" title-class="" :value="userPoap.start_at_formatted"/>
                <van-cell title="Complete" title-class="" :value="userPoap.end_at_formatted"/>
                <van-cell title="Checkin" title-class="" :value="userPoap.checkin_at_formatted"/>
                <van-cell title="Checkout" title-class="" :value="userPoap.checkout_at_formatted"/>
                <van-row>&nbsp;</van-row>
            </van-cell-group>
        </div>

        <van-cell-group inset>
            <van-button block round type="success" to="/poap/0">
                New POAP
            </van-button>
        </van-cell-group>
    </van-space>
</template>

<style>

:root:root {
    --van-grid-item-text-font-size: var(--van-font-size-xs);
}

</style>
